<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<header
  *ngIf="showSliderHeader"
  class="slider-title"
>
  <render-wysiwyg
    *ngIf="slice.settings.general.showSliderTitle && slice.settings.general.sliderTitle?.length > 0"
    [html]="slice.settings.general.sliderTitle"
    [textPaddingTop]="slice.settings.general.sliderTitlePadding?.textPaddingTop"
    [textPaddingBottom]="slice.settings.general.sliderTitlePadding?.textPaddingBottom"
    [textPaddingLeft]="slice.settings.general.sliderTitlePadding?.textPaddingLeft"
    [textPaddingRight]="slice.settings.general.sliderTitlePadding?.textPaddingRight">
  </render-wysiwyg>

  <ng-container
    *ngIf="arrowPosition === 'header-right';
    then sliderArrows">
  </ng-container>

</header>

<div
  class="slice-slider-wrapper"
  #sliceSliderWrapper
  [ngClass]="fxSlide"
  [class.scaleInit]="slice.settings.general.transitionType === 'cube'"
  [class.scaleTransition]="slice.settings.general.transitionType === 'cube' && isScale"
  [class.mobile]="isMobile"
  (touchstart)="showNavigationControls()">

  <swiper
    *ngIf="slidesRange.length > 0"
    (progress)="scale(true)"
    (setTransition)="scale(false)"
    (indexChange)="updateState()"
    (init)="resetSwiperAfterLazyImagesLoad()"
    [config]="config">
    <ng-template
      *ngFor="let slide of slidesRange; trackBy: trackBySlide"
      swiperSlide>
      <div
        [ngStyle]="{
          'margin-left': initialOffset(slide),
          'margin-right': lastOffset(slide)
        }">
        <render-slice-slot
          data-e2e="render-slice-slot"
          [slice]="slice"
          [slot]="(slide + 1).toString()"
          [ngStyle]="getSlotStyles(slots[slide])">
        </render-slice-slot>
      </div>
    </ng-template>
    <div
      slot="container-end"
      class="hidden">
      <ng-container *ngTemplateOutlet="slideDescriptionTemplate"></ng-container>
    </div>
  </swiper>

  <ng-container
    *ngIf="arrowPosition === 'inside-left-right' || arrowPosition === 'bottom-right';
    then sliderArrows">
  </ng-container>

  <div
    class="swiper-pagination-count"
    *ngIf="slice?.settings.general.pagination && this.isPagerStylecount">
    <button
      class="button-prev"
      (click)="arrowClick('prev')">
      <svg
        viewBox="0 0 11 16"
        fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z" />
      </svg>
    </button>
    <div class="slides-count">
      <span>{{ currentIndex + 1 }}</span>
      <span>|</span>
      <span>{{ slots.length }}</span>
    </div>
    <button
      class="button-next"
      (click)="arrowClick('next')">
      <svg
        viewBox="0 0 11 16">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
      </svg>
    </button>
    <ng-container *ngTemplateOutlet="slideDescriptionTemplate"></ng-container>
  </div>
</div>

<ng-template #sliderArrows>
  <div
    class="arrow-control"
    [ngClass]="{
      'arrow-control-mm-vertical': swiperDirectionVer,
      'arrow-control-mm-horizontal': swiperDirectionHor,
      'arrow-position-bottom-right': arrowPosition === 'bottom-right'
    }"
    *ngIf="(arrowIsIcon || arrowIsCustomIcon || arrowIsTitle) && isScrollPager">
    <div
      role="button"
      tabindex="0"
      (click)="arrowClick('prev')"
      class="swiper-arrow swiper-arrow-prev">
        <svg
          *ngIf="arrowIsIcon"
          viewBox="0 0 11 16"
          fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z" />
        </svg>
        <img
          *ngIf="arrowIsCustomIcon"
          alt="Anterior"
          aria-hidden="true"
          [src]="getArrowIcon('prev')"/>
        <render-wysiwyg
          *ngIf="arrowIsTitle"
          class="swiper-page-title"
          [html]="getArrowText('prev')">
        </render-wysiwyg>
    </div>
    <div
      role="button"
      tabindex="0"
      (click)="arrowClick('next')"
      class="swiper-arrow swiper-arrow-next">
      <svg
        *ngIf="arrowIsIcon"
        viewBox="0 0 11 16"
        fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
      </svg>
      <img
        *ngIf="arrowIsCustomIcon"
        alt="Siguiente"
        aria-hidden="true"
        [src]="getArrowIcon('next')">
      <render-wysiwyg
        *ngIf="arrowIsTitle"
        class="swiper-page-title"
        [html]="getArrowText('next')">
      </render-wysiwyg>
    </div>
  </div>
</ng-template>

<ng-template #slideDescriptionTemplate>
  <render-wysiwyg
    class="slide-description"
    [html]="slideDescription">
  </render-wysiwyg>
</ng-template>
